import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

const LOG_FILENAME = 'app_debug_log.txt';
const MAX_SIZE_BYTES = 5 * 1024 * 1024; // 5MB
const KEEP_SIZE_BYTES = 4 * 1024 * 1024; // Conservamos los últimos 4MB

/**
 * Añade un evento al log.
 */
export async function logEvent(message: string) {
    console.log(message);
    const timestamp = new Date().toISOString();
    const line = `[${timestamp}] ${message}\n`;

    try {
        // Añadimos el nuevo log
        await Filesystem.appendFile({
            path: LOG_FILENAME,
            data: line,
            directory: Directory.Documents,
            encoding: Encoding.UTF8,
        });

        // Comprobamos el tamaño
        const stat = await Filesystem.stat({
            path: LOG_FILENAME,
            directory: Directory.Documents,
        });

        if (stat.size > MAX_SIZE_BYTES) {
            console.warn(`🚨 Log file exceeds ${MAX_SIZE_BYTES} bytes. Truncating...`);
            await truncateLog();
        }
    } catch (err) {
        console.error("❌ Error writing log:", err);
    }
}

/**
 * Trunca el log dejando solo los últimos KEEP_SIZE_BYTES.
 */
async function truncateLog() {
    try {
        const file = await Filesystem.readFile({
            path: LOG_FILENAME,
            directory: Directory.Documents,
            encoding: Encoding.UTF8,
        });

        // Convertimos a bytes
        const text = file.data;
        const encoder = new TextEncoder();
        const bytes = encoder.encode(text);

        // Cortamos los últimos KEEP_SIZE_BYTES
        const start = bytes.length - KEEP_SIZE_BYTES;
        const slicedBytes = bytes.slice(start > 0 ? start : 0);

        // Convertimos de nuevo a string
        const decoder = new TextDecoder();
        const newText = decoder.decode(slicedBytes);

        // Sobreescribimos el fichero
        await Filesystem.writeFile({
            path: LOG_FILENAME,
            data: newText,
            directory: Directory.Documents,
            encoding: Encoding.UTF8,
        });

        console.log(`✅ Log truncated to last ${KEEP_SIZE_BYTES} bytes.`);
    } catch (err) {
        console.error("❌ Error truncating log:", err);
    }
}

/**
 * Descarga todo el contenido del log.
 */
export async function downloadLog(): Promise<string> {
    try {
        const file = await Filesystem.readFile({
            path: LOG_FILENAME,
            directory: Directory.Documents,
            encoding: Encoding.UTF8,
        });
        return file.data;
    } catch (err) {
        console.error("❌ Error reading log:", err);
        return '';
    }
}

/**
 * Obtiene el texto del log (p.ej., para mostrar en un modal).
 */
export async function getLogText(): Promise<string> {
    return await downloadLog();
}


let debugTapCount = 0;
let debugTimeout: ReturnType<typeof setTimeout> | null = null;
export let showDebugOption = false;
export function handleSecretTap() {
    if (showDebugOption) {
        console.log("🔒 Modo depuración ya activado");
        if (debugTimeout) {
            clearTimeout(debugTimeout);
            debugTimeout = null;
        }
        return;
    }
    // console.log("🔍 Se ha detectado un toque secreto");
    debugTapCount++;
    if (debugTapCount >= 10) {
        showDebugOption = true;
        // console.log("🔓 Modo depuración activado");
        debugTapCount = 0;
        if (debugTimeout) {
            clearTimeout(debugTimeout);
            debugTimeout = null;
        }
        return;
    }

    // Reinicia si no se toca en 3 segundos
    if (debugTimeout) {
        clearTimeout(debugTimeout);
    }
    debugTimeout = setTimeout(() => {
        debugTapCount = 0;
        console.log("⏳ Reiniciando contador de toques secretos");
        debugTimeout = null; // << Añadir esta línea
    }, 3000);
}